import * as React from 'react';
import Svg, { SvgProps, G, Path } from 'react-native-svg';

function SvgComponent(props: SvgProps) {
  return (
    <Svg width={183} height={63} {...props}>
      <G fill="#FFF" fillRule="evenodd">
        <Path
          d="M63.6 17.44H87v4h-9.36V46h-4.68V21.44H63.6v-4zm24.2 0h5.28l5.36 21.72h.16l5.64-21.72h4.84l5.64 21.72h.16l5.36-21.72h5.28L117.28 46h-4.96l-5.56-21.48h-.16L101 46h-5l-8.2-28.56zm40.72 0h10.44c4.64 0 8.12 1.28 10.52 3.84 2.28 2.4 3.44 5.88 3.44 10.44 0 4.52-1.16 8-3.44 10.44-2.4 2.56-5.88 3.84-10.52 3.84h-10.44V17.44zm4.68 4V42h4.88c3.56 0 6.16-.84 7.8-2.48 1.6-1.68 2.4-4.28 2.4-7.8 0-3.6-.8-6.24-2.4-7.84-1.64-1.64-4.24-2.44-7.8-2.44h-4.88zm36.52-4.56c3.36 0 6.16.88 8.32 2.64 2.08 1.68 3.32 4 3.76 6.88h-4.56c-.48-1.88-1.36-3.24-2.68-4.12-1.28-.88-2.92-1.28-4.92-1.28-3 0-5.24 1-6.76 3.08-1.4 1.84-2.08 4.4-2.08 7.68 0 3.36.68 5.96 2.04 7.76 1.48 1.92 3.8 2.92 6.92 2.92 2.04 0 3.72-.52 5-1.48 1.36-1.08 2.32-2.72 2.88-4.88h4.56c-.64 3.36-2.12 5.96-4.48 7.84-2.2 1.76-4.84 2.64-7.92 2.64-4.76 0-8.32-1.52-10.64-4.48-2.04-2.56-3.04-6-3.04-10.32 0-4.24 1.04-7.72 3.16-10.36 2.4-3.04 5.88-4.52 10.44-4.52z"
          fillRule="nonzero"
        />
        <Path d="M43 31v19.758L21.686 63 0 50.758V31l4.3 2.47v14.818L19 56.742V43.004l2.497 1.307L24 43v13.73l14.7-8.442V33.47L43 31zM21.503 5L24 6.273V37.67L21.5 39 19 37.7l.03-31.44L21.503 5zM21.5 0L43 12.083l-.004 14.498L38.7 29V14.327l-17.2-9.47-17.355 9.556L4.3 29 0 26.583l.069-14.462L21.5 0z" />
      </G>
    </Svg>
  );
}

const TwdcComponent = React.memo(SvgComponent);
export default TwdcComponent;
